import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-main)', paddingTop: '80px' }}>
      <section style={{ padding: '3rem 1.2rem 2rem', background: 'var(--gradient-hero)', textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <Link to="/" className="body-small" style={{ textDecoration: 'none', color: 'var(--text-secondary)', display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginBottom: '2rem' }}>
            <ArrowLeft size={16} /> Retour
          </Link>
          <h1 className="heading-hero" style={{ marginBottom: '1rem' }}>Conditions Générales d'Utilisation</h1>
        </div>
      </section>

      <section style={{ padding: '3rem 1.2rem' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>1. Objet</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités et conditions d'utilisation de la plateforme <strong>VAE Accompagnement</strong>, éditée par <strong>APDR de la VAE</strong> (SIREN : 833 761 133), ainsi que les droits et obligations des utilisateurs.<br /><br />
              En accédant et en utilisant la plateforme, l'utilisateur accepte sans réserve les présentes CGU.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>2. Services proposés</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              La plateforme propose des services d'accompagnement à la Validation des Acquis de l'Expérience (VAE) comprenant :<br /><br />
              - L'accès à une plateforme e-learning avec des contenus pédagogiques (cours, quiz, supports)<br />
              - La mise à disposition d'un Livret 2 détaillé<br />
              - Des séances d'accompagnement individuelles en visioconférence<br />
              - Des corrections personnalisées du Livret 2<br />
              - Des séances d'oral blanc de préparation<br />
              - La réservation de créneaux en ligne
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>3. Inscription et compte utilisateur</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              L'accès à certains services nécessite la création d'un compte. L'utilisateur s'engage à fournir des informations exactes et à maintenir la confidentialité de ses identifiants de connexion.<br /><br />
              L'utilisateur est seul responsable de l'utilisation de son compte et de toutes les actions effectuées sous ses identifiants.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>4. Accès aux contenus numériques</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              L'accès à la plateforme e-learning et aux contenus pédagogiques est valable pour une durée d'un (1) an à compter de la date d'achat.<br /><br />
              Conformément aux conditions d'accès aux contenus numériques, les formations, constituées exclusivement d'outils pédagogiques au format PDF, ne sont ni échangeables ni remboursables une fois l'accès activé.<br /><br />
              L'utilisateur s'engage à ne pas reproduire, copier, vendre, revendre ou exploiter à des fins commerciales tout ou partie des contenus de la plateforme sans autorisation écrite préalable.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>5. Paiement</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Les paiements sont effectués en ligne via la plateforme sécurisée Stripe. Le paiement peut être effectué en une fois ou en trois fois sans frais selon la formule choisie.<br /><br />
              Les prix sont indiqués en euros TTC sur la page des formules.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>6. Propriété intellectuelle</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              L'ensemble des contenus présents sur la plateforme (textes, images, vidéos, supports pédagogiques, quiz, présentations) est protégé par le droit d'auteur et reste la propriété exclusive d'APDR de la VAE.<br /><br />
              Toute reproduction, représentation, modification ou distribution de ces contenus sans autorisation est interdite et constitue une contrefaçon sanctionnée par le Code de la propriété intellectuelle.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>7. Responsabilité</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              APDR de la VAE s'efforce d'assurer la disponibilité et le bon fonctionnement de la plateforme, mais ne saurait être tenue responsable en cas d'interruption, de dysfonctionnement ou de perte de données.<br /><br />
              L'accompagnement VAE proposé ne garantit pas l'obtention du diplôme, celle-ci relevant de la décision souveraine du jury.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>8. Contact</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Pour toute question relative aux présentes CGU, vous pouvez nous contacter à : <a href="mailto:apdr.vae@gmail.com">apdr.vae@gmail.com</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
